import BigLogo from "@assets/images/logo.png";
import Logout from "@components/Logout";
import { Container, useTheme } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";

import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import { Link } from "react-router-dom";

const ResponsiveAppBar = () => {
  const theme = useTheme();

  return (
    <React.Fragment>
      <AppBar
        position="static"
        sx={{
          height: theme.customLayoutHeight.appNavBarHeight,
          boxShadow: "none",
          backgroundColor: "#f6f6f6",
          borderBottom: "2px solid #e7e7e7"
        }}
      >
        <Container maxWidth="xl" sx={{ height: "inherit" }}>
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              height: "inherit",
              gap: 4,
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <Box
              sx={{
                display: "flex",
                minWidth: "max-content",
                alignItems: "center",
                gap: "1rem"
              }}
            >
              <Link to="/">
                <img
                  src={BigLogo}
                  alt="The BrAIn by ANTEVENIO & dive"
                  width={400}
                />
              </Link>
            </Box>
            <Box className="w-full flex justify-end items-center">
              <Box
                className="mr-2"
                sx={{ display: "flex", alignItems: "center" }}
              >
                {/*<LanguageSelector color="white" />*/}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Logout color="white" />
              </Box>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </React.Fragment>
  );
};

export default ResponsiveAppBar;
